// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ba1025ec","239":"a34c137c","622":"6141c9fe","904":"022080da"}[chunkId] + ".chunk.js";
};